import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from "../lib/cx.js";
/** Link semântico sem depender de react-router (apps passam className ao Link). */
export function Link({ href, className, children, ...rest }) {
    return (_jsx("a", { href: href, className: cx("evolua-link", className), ...rest, children: children }));
}
//# sourceMappingURL=LinkLike.js.map